// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PublicationCreate
 */
export interface PublicationCreate {
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  description?: string;
}

/**
 * Check if a given object implements the PublicationCreate interface.
 */
export function instanceOfPublicationCreate(value: object): value is PublicationCreate {
  if (
    (!("projectId" in (value as Record<string, any>)) &&
      !("project_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["projectId"] === undefined &&
      (value as Record<string, any>)["project_id"] === undefined)
  )
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function PublicationCreateFromJSON(json: any): PublicationCreate {
  return PublicationCreateFromJSONTyped(json, false);
}

export function PublicationCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationCreate {
  if (json == null) {
    return json;
  }
  return {
    projectId: json["project_id"],
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
  };
}

export function PublicationCreateToJSON(json: any): PublicationCreate {
  return PublicationCreateToJSONTyped(json, false);
}

export function PublicationCreateToJSONTyped(
  value?: PublicationCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    project_id: value["projectId"],
    name: value["name"],
    description: value["description"],
  };
}
